import styled from 'styled-components';
import { Link } from 'gatsby';
import { capitalizedText } from '../atoms/capitalized-text';
import { linkStyle } from '../atoms/link';
import { baseFontSize } from '../atoms/font';

export const AuthorName = styled(Link)`
  ${capitalizedText};
  ${linkStyle}
  ${baseFontSize}
`;

export const AuthorNameWithoutLink = styled.span`
  ${capitalizedText};
  ${linkStyle}
  ${baseFontSize}

  &:hover {
    text-decoration: none;
  }
`;
